import { render, staticRenderFns } from "./clib-detail-modal.vue?vue&type=template&id=11521a64&scoped=true&"
import script from "./clib-detail-modal.vue?vue&type=script&lang=js&"
export * from "./clib-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./clib-detail-modal.vue?vue&type=style&index=0&id=11521a64&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11521a64",
  null
  
)

component.options.__file = "clib-detail-modal.vue"
export default component.exports